module.exports = "/_next/static/images/8f20d05331ec7ca828e34c9b791b9fa3-ppf-lg.png";